<template>
  <v-card>
    <div>
      <div style="display: flex; justify-content: space-between">
        <div style="align-self: center; font-size: 23px; font-weight: 600" class="pl-3">
          {{ edittype == 'create' ? 'Create Service' : 'Edit Service' }}
        </div>
        <div>
          <v-btn @click="$emit('close')" style="float: right" icon><v-icon>close</v-icon></v-btn>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <div class="pa-2">
      <div class="form-control" :class="{ 'has-error': errors.has('Service image') }">
        <uploadfile
          :data-vv-as="$t('Service image')"
          name="Service image"
          v-validate="'required'"
          v-model="input.photourl"
        ></uploadfile>
        <p class="text-error" v-if="errors.has('Service image')">
          {{ errors.first('Service image') }}
        </p>
      </div>
      <div class="pa-3">
        <div>Service name</div>
        <div class="form-control" :class="{ 'has-error': errors.has('name') }">
          <input
            :data-vv-as="$t('Service')"
            name="name"
            v-validate="'required'"
            type="text"
            v-model="input.name"
          />
          <p class="text-error" v-if="errors.has('name')">
            {{ errors.first('name') }}
          </p>
        </div>
        <div>Desciption EN</div>
        <div class="form-control" :class="{ 'has-error': errors.has('description') }">
          <AutoresizeTextarea
            :data-vv-as="$t('Description')"
            name="description"
            v-validate="'required'"
            type="text"
            v-model="input.description"
          >
          </AutoresizeTextarea>
          <p class="text-error" v-if="errors.has('description')">
            {{ errors.first('description') }}
          </p>
        </div>
        <div>Desciption TH</div>
        <div class="form-control" :class="{ 'has-error': errors.has('description_th') }">
          <AutoresizeTextarea
            :data-vv-as="$t('Description TH')"
            name="description_th"
            v-validate="'required'"
            type="text"
            v-model="input.description_th"
          >
          </AutoresizeTextarea>
          <p class="text-error" v-if="errors.has('description_th')">
            {{ errors.first('description_th') }}
          </p>
        </div>
      </div>
      <v-layout row wrap class="ma-0">
        <v-flex xs4>
          <div class="pl-3 pb-0">
            <div>Point</div>
            <div class="form-control" :class="{ 'has-error': errors.has('Point') }">
              <input
                :data-vv-as="$t('Point')"
                name="Point"
                v-validate="'required'"
                type="text"
                v-model="input.points"
              />
              <p class="text-error" v-if="errors.has('Point')">
                {{ errors.first('Point') }}
              </p>
            </div>
          </div></v-flex
        >

        <v-flex xs3 class="pl-2">
          <div>
            <div>Spend Time</div>
            <div class="form-control" :class="{ 'has-error': errors.has('Hour') }">
              <input
                :data-vv-as="$t('Hour')"
                name="Hour"
                placeholder="Hour"
                v-validate="'required'"
                type="text"
                @keypress="onlyNumber"
                v-model="time.hour"
              />

              <p class="text-error" v-if="errors.has('Hour')">
                {{ errors.first('Hour') }}
              </p>
            </div>
          </div></v-flex
        >
        <v-flex xs1>
          <div style="height: 34.4px"></div>
          <div class="text-xs-center">:</div>
        </v-flex>
        <v-flex xs3>
          <div>
            <div style="height: 22.4px"></div>
            <div class="form-control" :class="{ 'has-error': errors.has('Minute') }">
              <input
                :data-vv-as="$t('Minute')"
                name="Minute"
                placeholder="Minute"
                v-validate="'required|max_value:59'"
                type="text"
                @keypress="onlyNumber"
                v-model="time.minute"
              />

              <p class="text-error" v-if="errors.has('Minute')">
                {{ errors.first('Minute') }}
              </p>
            </div>
          </div></v-flex
        >
        <v-flex xs12 class="pl-3">
          <div>Available Day</div>
          <v-layout wrap>
            <v-flex xs3 class="pa-1">
              <multiselect
                :data-vv-as="$t('Available Day')"
                name="Available Day"
                :placeholder="'Available Day'"
                v-model="available_time.day"
                :options="[
                  'monday',
                  'tuesday',
                  'wednesday',
                  'thursday',
                  'friday',
                  'saturday',
                  'sunday'
                ]"
              ></multiselect>
            </v-flex>
            <v-flex xs3 class="form-control pa-1">
              <CustomTimepicker
                v-model="available_time.start"
                :data-vv-as="$t('Available Time - Start')"
                name="Available Time - Start"
              >
                <input
                  placeholder="Available Time - Start"
                  readonly
                  type="text"
                  :value="available_time.start"
                />
              </CustomTimepicker>
            </v-flex>
            <!-- :max="available_time.end" -->
            <!-- <v-flex xs3 class="form-control pa-1">
              <CustomTimepicker
                v-model="available_time.end"
                :min="available_time.start"
                :data-vv-as="$t('Available Time - End')"
                name="Available Time - End"
              >
                <input
                  placeholder="Available Time - End"
                  readonly
                  type="text"
                  :value="available_time.end"
                />
              </CustomTimepicker>
            </v-flex> -->
            <v-flex xs3>
              <v-btn color="primary" @click="addAvailable">{{ $t('Add') }}</v-btn>
            </v-flex>
          </v-layout>
          <template v-for="(available, index) in availableDayList">
            <v-layout wrap :key="index" class="mb-2">
              <v-flex xs4 class="pt-3">{{ available.day }}</v-flex>
              <v-flex xs6 class="pt-3">{{ available.start }}</v-flex>
              <v-flex xs2
                ><v-btn small fab flat @click="deleteAvailable(index)"
                  ><v-icon>close</v-icon></v-btn
                ></v-flex
              >
            </v-layout>
            <v-divider v-if="index != availableDayList.length - 1" :key="`divider_${index}`" />
          </template>
          <!-- <div class="form-control" :class="{ 'has-error': errors.has('Available Day') }">
            <multiselect
              :multiple="true"
              :data-vv-as="$t('Available Day')"
              v-validate="'required'"
              name="Available Day"
              :closeOnSelect="false"
              :taggable="true"
              :placeholder="'Available Day'"
              v-model="sortedDays"
              :options="availableOptions"
            ></multiselect>
            <p class="text-error" v-if="errors.has('Available Day')">
              {{ errors.first('Available Day') }}
            </p>
          </div> -->
        </v-flex>
        <!-- <v-flex xs4 class="pl-3 mt-3">
          <div>Available Time - Start</div>
          <div class="form-control" :class="{ 'has-error': errors.has('Available Time - Start') }">
            <CustomTimepicker
              v-model="available_time.start"
              :max="available_time.end"
              :data-vv-as="$t('Available Time - Start')"
              name="Available Time - Start"
              v-validate="'required'"
            >
              <input
                placeholder="Available Time - Start"
                readonly
                type="text"
                :value="available_time.start"
              />
            </CustomTimepicker>
            <p class="text-error" v-if="errors.has('Available Time - Start')">
              {{ errors.first('Available Time - Start') }}
            </p>
          </div>
        </v-flex>
        <v-flex xs4 class="pl-3 mt-3">
          <div>Available Time - End</div>
          <div class="form-control" :class="{ 'has-error': errors.has('Available Time - End') }">
            <CustomTimepicker
              v-model="available_time.end"
              :min="available_time.start"
              :data-vv-as="$t('Available Time - End')"
              name="Available Time - End"
              v-validate="'required'"
            >
              <input
                placeholder="Available Time - End"
                readonly
                type="text"
                :value="available_time.end"
              />
            </CustomTimepicker>
            <p class="text-error" v-if="errors.has('Available Time - End')">
              {{ errors.first('Available Time - End') }}
            </p>
          </div>
        </v-flex> -->
      </v-layout>
      <div class="text-xs-center mt-3">
        <v-btn @click="$emit('close')" color="grey" outline> {{ $t('cancel') }}</v-btn>
        <v-btn :loading="loading" @click="saveData" color="primary" depressed>
          {{ $t('Save') }}</v-btn
        >
      </div>
    </div>
  </v-card>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    uploadfile,
    Multiselect,
    AutoresizeTextarea,
    CustomTimepicker
  },
  props: ['editdata', 'edittype'],
  computed: {
    ...mapGetters(['selectedBot']),
    sortedDays: {
      get(val) {
        return this.input.available
      },
      set(val) {
        function s(a, b) {
          return daysOfWeek.indexOf(a) - daysOfWeek.indexOf(b) // basic sort function that compares the indexes of the two days
        }

        var daysOfWeek = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ] // array of days sorted

        this.input.available = val.sort(s)
      }
    }
  },
  data() {
    return {
      input: {
        name: '',
        photourl: '',
        points: '',
        spend_time: '',
        available: '',
        available_time: '',
        description: '',
        description_th: '',
        category_id: ''
      },
      available_time: {
        day: '',
        start: '',
        end: ''
      },
      time: {
        hour: '',
        minute: ''
      },
      availableDayList: [],

      loading: false,
      availableOptions: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ]
    }
  },
  created() {
    if (this.edittype == 'edit') {
      this.input = {
        ...this.editdata
        // available: this.editdata.available.split(','),
      }
      try {
        this.availableDayList = JSON.parse(this.editdata.available)
      } catch (error) {
        this.availableDayList = []
      }
      // this.available_time.start = this.editdata.available_time.split(',')[0]
      // this.available_time.end = this.editdata.available_time.split(',')[1]
      var spendtime = moment
        .utc(moment.duration(parseInt(this.editdata.spend_time), 'minutes').asMilliseconds())
        .format('HH:mm')
      this.time.hour = spendtime.split(':')[0]
      this.time.minute = spendtime.split(':')[1]
    }
  },
  methods: {
    async addAvailable() {
      if (!this.available_time.start || this.available_time.start == '') {
        await this.$swal.fire({
          title: this.$t('กรุณากรอกข้อมูล'),
          type: 'info',
          confirmButtonText: this.$t('Confirm'),
          showCancelButton: false,
          reverseButtons: true
        })
        return false
      }
      this.availableDayList.push(cloneDeep(this.available_time))
      this.available_time = {
        day: '',
        start: '',
        end: ''
      }
    },
    deleteAvailable(index) {
      this.availableDayList.splice(index, 1)
    },
    onlyNumber(event) {
      var result = event.charCode >= 48 && event.charCode <= 57
      if (result) {
        // return result;
      } else {
        event.preventDefault()
      }
    },
    async saveData() {
      var vm = this
      if (await vm.$validator.validate()) {
        var minutes = parseFloat(this.time.hour) * 60 + parseFloat(this.time.minute)
        var data = {
          pageid: vm.selectedBot.pageid,
          category_id: vm.editdata.category_id,
          productlist: [
            {
              name: vm.input.name,
              photourl: vm.input.photourl,
              points: parseInt(vm.input.points), // integer
              spend_time: minutes, // ส่งมาเป็นจำนวนาที
              // available: vm.input.available.join(','), // แล้วแต่ว่าจะส่งมายังไง
              available: JSON.stringify(vm.availableDayList),
              // available_time: vm.available_time.start + ',' + vm.available_time.end,
              description: vm.input.description,
              description_th: vm.input.description_th,
              category_id: vm.editdata.category_id
            }
          ]
        }
        this.loading = true
        if (this.edittype == 'create') {
          api.postmjdservicesproduct(data, async (err, response) => {
            if (response.responsecode == 200) {
              await this.$swal.fire({
                type: 'success',
                text: 'สำเร็จ'
              })
            }
            this.$emit('oncreate', response.data[0])
          })
        } else {
          api.putmjdservicesproduct(
            {
              ...data,
              product_id: this.editdata.id,
              ...data.productlist[0]
            },
            async (err, response) => {
              if (response.responsecode == 200) {
                await this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
              this.$emit('onedit', { ...data, id: this.editdata.id })
            }
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/EditService.vue